/**
 * @see https://app.split.io/org/5a082380-292e-11ec-80ff-06e6ab71fcc5/ws/5a1765c0-292e-11ec-80ff-06e6ab71fcc5/splits
 */
export enum SplitFlagEnum {
  FeatureRehabHistory = 'feature_rehab_history',
  FeatureReportFeedback = 'feature_report_feedback',
  FeatureDrawManagement = 'feature_draw_management',
  FeatureInspectorOnboarding = 'feature_inspector_onboarding',
  FeatureContractorReportCard = 'feature_contractor_report_card',
  FeatureMfa = 'feature_mfa',
  ShowAIEnhancedPhotoSphere = 'show_ai_enhanced_photo_sphere',
}

export const splitNames = Object.values(SplitFlagEnum);
